const moment = require('moment-jalaali');

export default function convertGregorianToJalali(miladiDate, hour = false) {
	if (hour) {
		const time = moment(miladiDate, 'YYYY-MM-DD HH:mm:ss');
		const jalaliDate = time.format('jYYYY/jMM/jDD');
		const dateWithHour = `${time.format('HH:mm')} - ${jalaliDate}`;
		return dateWithHour;
	}
	const jalaaliDate = moment(miladiDate, 'YYYY-MM-DD').format('jYYYY-jMM-jDD');
	return jalaaliDate;
}
